import React from 'react';
import { UserFields } from './user_components/UserFields';
import { ROLE } from '../../constants';

export default function NewUser(props) {
    if (props.role !== ROLE.director) return null;
    return (
        <UserFields
            pageTitle='add_user'
            cashRegistersList={props.organization.cashRegisters}
        />
    );
}
